import { MessageBar, PrimaryButton, Stack, Text } from "@fluentui/react";
import PwBuildBadge from "./PwBuildBadge";
import { observer, inject } from "mobx-react";
import { Component } from "react";
import PwProps from "../props/PwProps";
import { api } from "../utils/Api";
import { MenuItemRaw, ReportRaw, SelectOption, ReportOption } from '../types';
import { PwSearchableSelectOption } from './PwSearchableSelect';
import PwLoading from "./PwLoading";
import PwSearchableSelect from "./PwSearchableSelect";
import PwSheetHeader from "./PwSheetHeader";

interface PwImportProps extends PwProps{}

interface PwImportState {
  modules: SelectOption[];
  moduleSelected: SelectOption | null;
  reports: ReportOption[];
  reportSelected: ReportOption | null;
  isLoading: boolean;
}

@inject('uiStore')
@observer
export default class PwImport extends Component<PwImportProps, PwImportState> {

  constructor(props: PwImportProps) {
    super(props);
    this.state = {
      modules: [],
      moduleSelected: null,
      reports: [],
      reportSelected: null,
      isLoading: false
    }
  }
  async componentDidMount() {
    await this.getReportsMenu();
  }

  toggleLoading() {
    this.setState({
      isLoading: !this.state.isLoading
    })
  }

  async getReportsMenu() {
    this.toggleLoading();
    const items: MenuItemRaw[] = await api.Get('Menu/GetAddInItems').then(({data}) => data.Data)
    this.setState({
      modules: items.reduce((prev: MenuItemRaw[], curr: MenuItemRaw) => {
        const exists = prev.find((x) => x.Code === curr.Code);
        if(!exists) {
          prev.push(curr);
        }
        return prev;
      }, []).map((x): SelectOption => ({ key: x.Code, text: x.Description }))
    })
    this.toggleLoading();
  }

  async onSelectModule(option: PwSearchableSelectOption | null) {
    if (!option) return;
    this.toggleLoading();
    const reports: ReportRaw[] = await api.OData(`ODataReports/GetReportsInModule(module='${option.key}')`).then(({data}) => data.value);
    this.setState({
      moduleSelected: { key: String(option.key), text: option.text },
      reports: reports
        .sort((a, b) => a.Title.localeCompare(b.Title, undefined, { sensitivity: 'base' }))
        .map((x): ReportOption => ({ key: x.ID, text: x.Title, description: x.Description, tableName: x.Name })),
      reportSelected: null,
    });
    this.props.uiStore?.setReportSelected(null);
    this.toggleLoading();
  }

  onSelectReport(option: PwSearchableSelectOption | null) {
    const typed: ReportOption | null = option
      ? { key: String(option.key), text: option.text, description: option.description, tableName: option.tableName }
      : null;
    this.setState({ reportSelected: typed });
    this.props.uiStore?.setReportSelected(typed);
  }

  goToGenerateReport() {
    this.props.uiStore?.changeSection('report');
  }

  render() {
    return <div>
      { this.state.isLoading && <PwLoading />}
      <PwSheetHeader />
      {this.props.uiStore?.userName ? (
        <Text variant="small" style={{ color: "#323130", display: "block", marginBottom: "4px" }}>
          {this.props.uiStore.userName}
        </Text>
      ) : null}
      {(this.props.uiStore?.tenantName || this.props.uiStore?.userRole) ? (
        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "8px" }}>
          <Text variant="small" style={{ color: "#605e5c" }}>
            {this.props.uiStore.tenantName}
          </Text>
          <Text variant="small" style={{ color: "#605e5c" }}>
            {this.props.uiStore.userRole}
          </Text>
        </div>
      ) : null}
      <Stack style={{ marginBottom: '24px'}}>
        <Stack.Item>
          <MessageBar dismissButtonAriaLabel="Close">
            Seleccione la aplicación, módulo o catálogo del que proviene el reporte y el reporte que desee generar.
          </MessageBar>
        </Stack.Item>
      </Stack>
      <Stack style={{ marginBottom: '24px' }}>
        <PwSearchableSelect
          label="Aplicación"
          options={this.state.modules}
          selectedOption={this.state.moduleSelected}
          onChange={(option) => this.onSelectModule(option)}
          placeholder="Buscar aplicación..."
        />
      </Stack>
      <Stack style={{ marginBottom: '24px' }}>
        <PwSearchableSelect
          label="Reporte"
          options={this.state.reports}
          selectedOption={this.state.reportSelected}
          onChange={(option) => this.onSelectReport(option)}
          disabled={this.state.reports.length === 0}
          placeholder="Buscar reporte..."
        />
      </Stack>
      {this.state.reportSelected && <Stack>
        <MessageBar>
          { this.state.reportSelected.description }
        </MessageBar>
      </Stack>}
      <Stack style={{ marginTop: '40px'}}>
        <Stack.Item style={{ textAlign: 'center' }}>
          <PrimaryButton disabled={!this.state.reportSelected} onClick={() => this.goToGenerateReport()}>
            Siguiente
          </PrimaryButton>
        </Stack.Item>
      </Stack>
      <PwBuildBadge />
    </div>
  }
}
